import { render, staticRenderFns } from "./UserProfileLibrary.vue?vue&type=template&id=3b90a244&scoped=true&"
import script from "./UserProfileLibrary.vue?vue&type=script&lang=js&"
export * from "./UserProfileLibrary.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileLibrary.vue?vue&type=style&index=0&id=3b90a244&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b90a244",
  null
  
)

export default component.exports